<template>
  <div class="gx-ann-detail">
    <top-banner :show-notification="true" @logo="goHome">
      <template #center>
        <button class="gx-ann-detail__back" @click="goList">
          <i class="el-icon-arrow-left"></i>返回公告列表
        </button>
      </template>
    </top-banner>

    <div v-loading="loading" class="gx-ann-detail__box">
      <div v-if="error" class="gx-ann-detail__error">
        <p>{{ error }}</p>
        <button type="button" class="gx-ann-detail__btn" @click="goList">返回列表</button>
      </div>
      <template v-else-if="detail">
        <div class="gx-ann-detail__meta">
          <span class="gx-ann-detail__tag" :class="'gx-ann-detail__tag--' + (detail.type || 'update')">
            {{ typeLabel(detail.type) }}
          </span>
          <span v-if="detail.important" class="gx-ann-detail__tag gx-ann-detail__tag--important">重要</span>
          <span class="gx-ann-detail__time">{{ formatTime(detail.published_at || detail.start_at) }}</span>
        </div>
        <h1 class="gx-ann-detail__title">{{ detail.title }}</h1>
        <div v-if="detail.cover_url" class="gx-ann-detail__cover">
          <img :src="detail.cover_url" alt="" />
        </div>
        <div class="gx-ann-detail__content" v-html="detail.content"></div>
      </template>
    </div>
  </div>
</template>

<script>
import TopBanner from '@/components/newUi/TopBanner.vue'
import { announcementDetail, announcementRead } from '@/api/main/announcement'

export default {
  name: 'AnnouncementDetailPage',
  components: { TopBanner },
  data() {
    return {
      loading: false,
      detail: null,
      error: ''
    }
  },
  created() {
    this.load()
  },
  watch: {
    '$route.params.id'() {
      this.load()
    }
  },
  methods: {
    goHome() {
      this.$router.push('/ucenter')
    },
    goList() {
      this.$router.push('/new_announcement')
    },
    typeLabel(type) {
      return type === 'activity' ? '活动' : '系统更新'
    },
    formatTime(ts) {
      if (!ts) return ''
      const d = new Date(typeof ts === 'number' && ts < 1e12 ? ts * 1000 : ts)
      if (isNaN(d.getTime())) return String(ts)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    async load() {
      const id = this.$route.params.id
      if (!id) {
        this.error = '公告不存在'
        return
      }
      this.loading = true
      this.error = ''
      this.detail = null
      try {
        const res = await announcementDetail(id)
        if (res && res.code === 200 && res.data) {
          this.detail = res.data
          try { await announcementRead({ id }) } catch (e) { /* ignore */ }
        } else {
          this.error = (res && res.msg) || '公告不可见或不存在'
        }
      } catch (e) {
        this.error = '加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.gx-ann-detail { min-height: 100vh; background: #F5F6FA; }
.gx-ann-detail__back {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 7px 14px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(255, 255, 255);
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 auto;
}
.gx-ann-detail__box {
  max-width: 800px;
  margin: 20px auto 40px;
  padding: 28px 20px 64px;
  background: #fff;
  border-radius: 14px;
  min-height: 320px;
}
.gx-ann-detail__error { text-align: center; padding: 64px 0; color: #8A95B0; }
.gx-ann-detail__btn {
  margin-top: 12px; border: none; background: #C8443C; color: #fff;
  padding: 8px 18px; border-radius: 8px; cursor: pointer;
}
.gx-ann-detail__meta { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.gx-ann-detail__tag {
  font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 4px;
  background: #EEF1F7; color: #5A6478;
}
.gx-ann-detail__tag--update { background: rgba(64,128,255,.12); color: #3A6FE0; }
.gx-ann-detail__tag--activity { background: rgba(255,122,40,.12); color: #E06A1A; }
.gx-ann-detail__tag--important { background: rgba(220,60,60,.12); color: #C8443C; }
.gx-ann-detail__time { font-size: 12px; color: #A8B0C2; margin-left: auto; }
.gx-ann-detail__title { margin: 0 0 18px; font-size: 24px; color: #1A1A2E; line-height: 1.4; }
.gx-ann-detail__cover {
  width: 100%; aspect-ratio: 16/9; border-radius: 10px; overflow: hidden;
  margin-bottom: 20px; background: #EEF1F7;
}
.gx-ann-detail__cover img { width: 100%; height: 100%; object-fit: cover; display: block; }
.gx-ann-detail__content {
  font-size: 15px; line-height: 1.8; color: #2A2A3E; word-break: break-word;
}
.gx-ann-detail__content >>> img { max-width: 100%; height: auto; border-radius: 6px; }
.gx-ann-detail__content >>> p { margin: 0 0 12px; }
</style>
